module.exports = __webpack_public_path__ + "static/media/two.8f0c6e2e.jpg";